import { useLocation, useNavigate } from "react-router-dom";
import "./DNBCourses.css";
import Navbar from "../../Navbar/Navbar";
import NavbarLocation from "../../Navbar/NavbarLocation";
import SEO from "../../SEO/SEO";

function DNBOrthopedics() {
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname.toLowerCase();

  let locationFilter = null;
  let basePath = "/Orthopedics";
  if (path.includes("ashwinitraumacentre")) {
    locationFilter = "Ashwini Trauma Centre";
    basePath = "/AshwiniTraumaCentre/Orthopedics";
  }

  return (
    <>
      {locationFilter ? <NavbarLocation /> : <Navbar />}
      <SEO
        title="DNB Orthopedics at Ashwini Trauma Centre, Odisha | Accredited Postgraduate Training"
        description="Join the DNB Orthopedics program at Ashwini Trauma Centre, Cuttack, Odisha. Accredited by NBE, this 3-year program offers intensive training in trauma care, joint replacement, and musculoskeletal disorders. 2 seats: Post MBBS & Post Diploma."
        keywords="DNB Orthopedics, DNB Orthopaedics Post MBBS, Post Diploma Orthopedic Surgery, NBE DNB Ortho, Ashwini Trauma Centre DNB, Trauma Surgery Training India, DNB Joint Replacement Odisha, Orthopedic Postgraduate Course, Best DNB Orthopedics Hospital"
      />

      <div className="dnb dnb-respiratory">
        <button
          className="btn btn-danger position-absolute"
          onClick={() => navigate(basePath)}
        >
          Orthopedics & Trauma Care
        </button>

        <section className="text-center banner">
          <h1 className="fw-bold">
            DNB Orthopedics at Ashwini Trauma Centre, Odisha
          </h1>
          <p className="text-danger fs-5">
            NBE-Accredited Postgraduate Training in Orthopedic Surgery
            <span className="text-success fw-semibold">
              {" "}
              (2 Seats – 1 Post MBBS, 1 Post Diploma)
            </span>
          </p>
        </section>

        <section>
          <h2>Program Overview</h2>
          <p>
            The <strong>DNB Orthopedics</strong> program at Ashwini Hospital is
            a structured 3-year postgraduate residency that focuses on
            comprehensive training in bone, joint, trauma, and spine care.
            Recognized by the{" "}
            <strong>National Board of Examinations (NBE)</strong>, it is open to{" "}
            <strong>Post MBBS</strong> and <strong>Post Diploma</strong>{" "}
            (D.Ortho) candidates.
          </p>
          <p>
            The program provides rigorous clinical, surgical, and academic
            exposure to prepare residents for independent practice in
            Orthopedics and allied specialties.
          </p>
        </section>

        <section className="highlight-box">
          <h2>Why Choose Ashwini Hospital?</h2>
          <ul>
            <li>High-volume trauma and joint surgery center</li>
            <li>
              Experienced faculty including MCh and DNB orthopedic consultants
            </li>
            <li>
              Advanced orthopedic infrastructure with modular OTs and C-arm
            </li>
            <li>Focus on clinical independence and academic excellence</li>
          </ul>
        </section>

        <section>
          <h2>Key Features</h2>
          <ul>
            <li>
              NBE-accredited DNB program for <strong>Post MBBS</strong> and{" "}
              <strong>Post Diploma</strong> students
            </li>
            <li>
              Comprehensive exposure to trauma, arthroplasty, spine, and sports
              injuries
            </li>
            <li>
              Daily ward rounds, emergency duties, and surgical assistance
            </li>
            <li>Weekly academic sessions, seminars, and journal clubs</li>
            <li>
              Case documentation, thesis guidance, and conference participation
            </li>
          </ul>
        </section>

        <section>
          <h2>Infrastructure Highlights</h2>
          <ul>
            <li>
              Fully-equipped Ortho OT with C-arm, arthroscopy, and trauma kits
            </li>
            <li>
              24/7 Emergency Trauma Services with Radiology and ICU backup
            </li>
            <li>
              Rehabilitation support with Physiotherapy and Occupational Therapy
            </li>
            <li>In-house Digital X-ray, CT, and MRI imaging</li>
            <li>Dedicated orthopedic wards and surgical ICU</li>
          </ul>
        </section>

        <section>
          <h2>Course Duration</h2>
          <p>
            <strong>3 Years</strong> of intensive residency with rotational
            postings, academic activities, and surgical training.
          </p>
        </section>

        <section className="apply-box">
          <h2>How to Apply</h2>
          <ol>
            <li>
              <strong>Eligibility:</strong> MBBS from a recognized institution +
              1-year internship. For Post Diploma route,{" "}
              <strong>D.Ortho</strong> or equivalent is mandatory.
            </li>
            <li>
              <strong>Application Process:</strong> Apply via the{" "}
              <a
                href="https://nbe.edu.in"
                target="_blank"
                rel="noopener noreferrer"
              >
                NBE website
              </a>{" "}
              by filling the form, uploading documents, and submitting the fee.
            </li>
            <li>
              <strong>Entrance:</strong> Admission for MBBS is via{" "}
              <strong>NEET PG</strong>; for Diploma, via{" "}
              <strong>DNB-PDCET</strong>. Both followed by centralized
              counseling by NBEMS.
            </li>
          </ol>
        </section>

        <section>
          <h2>Career Opportunities</h2>
          <ul>
            <li>
              Orthopedic Surgeon in multispecialty hospitals and trauma units
            </li>
            <li>
              Fellowships in Spine Surgery, Arthroscopy, and Joint Replacement
            </li>
            <li>Academic careers in Medical Colleges</li>
            <li>Opportunities abroad with recognized orthopedic skills</li>
          </ul>
        </section>

        <section className="contact-box">
          <h2>Admission Helpdesk</h2>
          <p>
            <strong>Ashwini Hospital – Cuttack, Odisha</strong>
          </p>
          <p>📧 Email: academic@ashwinihospital.com</p>
          <p>📞 Phone: +91-XXXXXXXXXX</p>
          <p>
            🌐 Website:{" "}
            <a
              href="https://www.ashwinihospital.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              ashwinihospital.com
            </a>
          </p>
          <p>
            🔗 NEET PG Info:{" "}
            <a
              href="https://nbe.edu.in"
              target="_blank"
              rel="noopener noreferrer"
            >
              nbe.edu.in
            </a>
          </p>
        </section>
      </div>
    </>
  );
}

export default DNBOrthopedics;
